<brightside-web-transaction-history
  [transactionsHistory]="transactionsHistory"
  [hasMoreTransactions]="hasMoreTransactions"
  (loadMoreClicked)="loadMore()">
  <brightside-web-account-header
    *ngIf="(currentAccountInfo | async) as account"
    [title]="account.accountDisplayName"
    [balance]="account.availableBalance">
    <div extra-details *ngIf="account.fundsSource.autoSaveSchedule.status !== 'notStarted'">
      <typography-legacy text-xsmall-regular color="var(--gray-50)">
        <div class="autosave-icon"
             [ngClass]="{'active': account.fundsSource.autoSaveSchedule.status === 'active'}">
          {{ 'AUTOSAVE' | translate }}
        </div>
      </typography-legacy>
    </div>
  </brightside-web-account-header>
</brightside-web-transaction-history>
